function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#212A33",
  fillRule: "evenodd",
  d: "M3 7.126v2.141A2.01 2.01 0 0 0 2 11a2 2 0 0 0 3.732 1h2.142a4 4 0 0 1-.924 1.702A4 4 0 1 1 3 7.126M6 6v3h3a2 2 0 0 1 1.995 1.85L11 11v2a1 1 0 0 1-1.993.117L9 13v-2H6a2 2 0 0 1-1.995-1.85L4 9V6zm6.5-6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m-2.086 2.122a2.5 2.5 0 0 0 3.464 3.464zM5 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4m7.5 0c-.51 0-.983.152-1.378.414l3.464 3.464A2.5 2.5 0 0 0 12.5 1"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/service/ic_wheelchair_inaccessible.svg";
export { SvgComponent as ReactComponent };